import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './clerk-overrides.css';
import App from './App';
import AppCapacitor from './AppCapacitor';
import { Capacitor } from '@capacitor/core';
import reportWebVitals from './reportWebVitals';
import { debugLog } from './utils/debug';

// Use AppCapacitor for native (Clerk SDK won't load in WebView)
// Use App for web (Clerk SDK works normally)
const AppComponent = Capacitor.isNativePlatform() ? AppCapacitor : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppComponent />
  </React.StrictMode>
);

// Frontend ready banner (shows in browser console)
debugLog('🚀 RUNIUM FRONTEND READY 🚀');

// Register Service Worker for notifications only (simplified to prevent blocking)
if ('serviceWorker' in navigator) {
  // Use setTimeout to defer service worker registration and prevent blocking page load
  setTimeout(() => {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          debugLog('[SW] Minimal notification service worker registered:', registration.scope);
          
          // Check for updates and force update if available (helps with mobile cache issues)
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker available - force activation
                  debugLog('[SW] New service worker available, forcing update...');
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                }
              });
            }
          });
        })
        .catch((error) => {
          debugLog('[SW] Registration failed:', error);
        });
    });
  }, 1000); // Delay service worker registration by 1 second to ensure page loads first
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
